import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { settlementAmountApi } from '../services/api/settlementAmount';
import type { AdminSettlementAmountInfo } from '../services/api/settlementAmount';
import type { SettlementFilters } from '../types/settlement';
import type { SettlementSortOrder } from '../types/settlement';

export function useSettlements(initialPage: number = 1, initialSize: number = 10) {
  const [page, setPage] = useState(initialPage);
  const [size, setSize] = useState(initialSize);

  const [filters, setFilters] = useState<SettlementFilters>({
    searchKeyword: '',
    sortBy: 'dtRegist',
    sortOrder: 'DESC' satisfies SettlementSortOrder,
  });

  const {
    data,
    isLoading,
    isFetching,
    error,
  } = useQuery({
    queryKey: ['settlements', page, size, filters],
    queryFn: () =>
      settlementAmountApi.getList({
        page,
        size,
        searchKeyword: filters.searchKeyword || undefined,
        startDate: filters.startDate,
        endDate: filters.endDate,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        settlementStatus: filters.settlementStatus,
      }),
    placeholderData: prev => prev,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    settlements: (data?.content ?? []) as AdminSettlementAmountInfo[],
    pagination: data?.pagination,
    summary: data?.summary,
    isLoading,
    isFetching,
    error,

    page,
    size,
    setPage,
    setSize,

    filters,
    setFilters,
  };
}
